<template>
  <div class="form-div">
     <div><Checkbox v-model="isCheck" @on-change="changeCheck">居民小组信息</Checkbox></div>
     <Form v-show="isCheck" class="isForm" label-position="right" :label-width="120">
       <FormItem class="isNoWidth">
              <span slot="label">组别:</span>
              <Input placeholder="请输入您的组别"  v-model="formDataResident.groupName" />
        </FormItem>
       <FormItem class="isNoWidth">
             <span slot="label">组内职位:</span>
              <Select clearable v-model="formDataResident.groupType" >
                <Option
                v-for="item in groupType"
                :value="item.dictKey"
                :key="item.dictKey"
                >{{ item.dictValue }}</Option>
              </Select>
        </FormItem>
     </Form>
  </div>
</template>

<script>
export default {
  props:{
    residentCheck:{
      type:Boolean,
      default:()=>{
        return false
      }
    },
    formDataResident:{
      type:Object,
      default:()=>{
        return {}
      }
    },
    userId:{
            type:Object,
            default:()=>{
                return ''
            }
        },
  },
  data(){
    return{
      isCheck:false,
      groupType:[
        //  {dictKey:'1',dictValue:'组员'},
        //  {dictKey:'2',dictValue:'副组长'},
        //  {dictKey:'3',dictValue:'组长'},
      ]
    }
  },
  created(){
    this.getDetail()
    this.getDicType('GROUP_POSITION','groupType')
    if(this.residentCheck == true){
      this.isCheck = true
    }
  },
  methods:{ 
    changeCheck(val){
      this.isCheck = val
      this.$emit('changeResident',val)
      // console.log(val);
    },
    getDetail(){
          if(this.userId && this.userId != ''){
            this.$get('/syaa/api/syuser/pc/residentArchive/selectUserRegionGroup',{
              userId:this.userId,
              // familyId:this.familyId
            }).then(res=>{
              if(res.code == 200){
                  this.$emit('getResident',res.data)
              }else{
                this.$Message.error({
                  content:'居民小组信息获取失败',
                  background:true
                })
                return
              }
            })
          }
          
        },
         // 获取字典接口的公共方法
        getDicType(type,model){
            this.$get('/voteapi/api/common/sys/findDictByDictType',{
                dictType:type
            }).then(res=>{
                this[model] = res.dataList
            })
        },
  },
   watch:{
     residentCheck:{
       hanlder(val,newVal){
         if(val){
           this.isCheck = val
         }
       }
     }
   }
}
</script>

<style lang="less" scoped>
.form-div{
    width:100%;
    user-select: none;
    .isForm{
        display: flex;
        flex-wrap: wrap;
        .isWidth{
        width: 40%;
        margin-right: 40px;
        }
        .isNoWidth{
            width: 100%;
        }
    }
    
}
/deep/.validate {
  &::before {
    content: "*";
    display: inline-block;
    margin-right: 4px;
    line-height: 1;
    font-family: SimSun;
    font-size: 14px;
    color: #ed4014;
  }
}
/deep/.ivu-date-picker{
    display: inline;
}
</style>